import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const NavBreadcrumbWrapper = styled.div`
  margin-top: 5.6875rem;
  margin-bottom: 2.3125rem;
  margin-left: 2rem;
  display: inline-block;
  pointer-events: none;
  color: ${themeGet('colors.spinDark')};
  a {
    pointer-events: all;
  }
  .arrow {
    margin-right: 0.6875rem;
    .arrowLeft {
      transform: scaleX(-1);
      height: 11px;
      position: relative;
      top: -4px;
    }
  }
  @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 1.6875rem;
    margin-left: 0;
  }
`;
